import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { borderRadius, size } from '@twisto/styles'

export const container = (theme: Theme) => css`
  border: 1px solid ${theme.palette.neutral[300]};
  border-radius: ${borderRadius.sm};
  padding: ${size[32]} ${size[40]};
`

export const cellIndent = css`
  padding-left: ${size[8]};
`

export const table = css`
  margin-top: ${size[16]};
`
